import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M15 8H5V6c0-1.654 1.346-3 3-3h3c.957 0 1.866.465 2.431 1.245.164.225.479.273.698.111a.4995.4995 0 0 0 .112-.698C13.488 2.62 12.277 2 11 2H8C5.794 2 4 3.794 4 6v2c-1.105 0-2 .895-2 2v7c0 1.105.895 2 2 2h11c1.105 0 2-.895 2-2v-7c0-1.105-.895-2-2-2z',
  ],
  height: 20,
  width: 20,
});
